module.exports = __webpack_public_path__ + "img/585.8f8d1bc9.jpg";